var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#734ACC",
    d: "M6 10.226c0-.442.33-.798.737-.798h.669c.407 0 .737.356.737.798v3.548c0 .442-.33.797-.737.797h-.669c-.407 0-.737-.355-.737-.797z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC8CE1",
    d: "M16.286 10.131c0-.385.33-.703.737-.703h.668c.408 0 .738.318.738.703v2.88c0 .386-.33.703-.738.703h-.668c-.407 0-.737-.317-.737-.703z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#936ED8",
    d: "M13.714 11.884a.74.74 0 0 1 .737-.741h.669a.74.74 0 0 1 .737.741v4.517a.74.74 0 0 1-.737.742h-.669a.74.74 0 0 1-.737-.742z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6640C7",
    d: "M8.571 6.33c0-.42.33-.759.738-.759h.668a.75.75 0 0 1 .737.759v6.197c0 .42-.33.759-.737.759H9.31a.75.75 0 0 1-.738-.759z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8961D4",
    d: "M11.143 7.611c0-.415.33-.754.737-.754h.669c.407 0 .737.339.737.754v10.492c0 .415-.33.754-.737.754h-.669a.746.746 0 0 1-.737-.754z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZig);
export default __webpack_public_path__ + "static/media/zig.c378bf7d7082bca6099cb277a641e427.svg";
export { ForwardRef as ReactComponent };